// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2QPow","validationTips":"StatementDescriptor_validationTips__1H-gq"};